import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Row, Col, InputGroup, Dropdown, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SubcategoryService from '../../service/SubcategoryService';
import LocationService from '../../service/LocationService';
import icon1 from '../../assets/icon-one.svg';
import icon2 from '../../assets/icon-two.svg';
import icon3 from '../../assets/icon-three.svg';
import icon4 from '../../assets/icon-four.svg';
import icon5 from '../../assets/icon-five.webp';
import icon6 from '../../assets/icon-six.webp';


const SearchSection = () => {
  const [location, setLocation] = useState('');
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState('');
  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [showLocationSuggestions, setShowLocationSuggestions] = useState(false);
  const [showSubcategory, setShowSubcategory] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {

    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const subcategoriesResponse = await SubcategoryService.getSubcategoriesByCategory();
      setSubcategories(subcategoriesResponse);
    } catch (error) {
      console.error('Error fetching subcategories:', error);
    }
  };

  const handleLocationChange = async (e) => {
    const newLocation = e.target.value;
    setLocation(newLocation);

    if (newLocation.length >= 3) {
      setLoading(true);
      setShowLocationSuggestions(true);
      try {
        const response = await LocationService.getLocationByName(newLocation);
        setLocationSuggestions(response);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching location suggestions:', error);
        setLoading(false);
        setShowLocationSuggestions(false);
      }
    } else {
      setShowLocationSuggestions(false);
      setLoading(false);
    }
  };

  const handleLocationSelect = (selectedLocation) => {
    setLocation(selectedLocation.location); // For display in the input field
    setShowLocationSuggestions(false);
  };

  const handleSearch = () => {
    const selectedSubcategoryData = subcategories.find(sub => sub.name === selectedSubcategory);
    if (selectedSubcategoryData) {
      sessionStorage.setItem("subcategoryId", selectedSubcategoryData.id);
    }

    // const formattedSubcategory = selectedSubcategory.toString().trim().replace(/\s+/g, '-');
    const formattedSubcategory = "Towing-and-Recovery";

    const searchlocation = location.trim().replace(/,\s*/g, '-');
    sessionStorage.removeItem("shopType");

    const url = `/${formattedSubcategory}/service-near-me/${searchlocation}`;
    navigate(url.toLowerCase());
  };

  const handleLinks = (subcategory) => {
    const selectedSubcategoryData = subcategories.find(sub => sub.name === subcategory);
    if (selectedSubcategoryData) {
      sessionStorage.setItem("subcategoryId", selectedSubcategoryData.id);
    }

    const formattedSubcategory = (selectedSubcategoryData?.name).toString().trim().replace(/\s+/g, '-');
    sessionStorage.removeItem("shopType");

    const searchlocation = ['Phoenix-AZ-USA', 'Fresno-CA-USA', 'Dallas-TX-USA', 'Washington-DC-USA', 'Beaumont-CA-USA', 'Dallas-GA-USA',]
    const randomlocation = searchlocation[Math.floor(Math.random() * searchlocation.length)];

    const url = `/${formattedSubcategory}/service-near-me/${randomlocation}`;
    navigate(url.toLowerCase());
  };

  const handleSubcategorySelect = (subcategory) => {
    setSelectedSubcategory(subcategory);
    setShowSubcategory(false);
  };

  return (<>
    <section className="home_search position-relative">
      <Container>
        <Row className="justify-content-center">
          <Col md={10} sm={12} className='px-md-0 mb-lg-5 mb-md-4 mb-3'>
            <h1>Find Towing <br/>Service Near You</h1>
            <h5 className="mb-2">
              Get fast, reliable roadside assistance 24/7, wherever you are. Our professional <br/>
              team is always ready to help you get back on the road quickly and safely.</h5>

            {/*p className="search_cont">Stop worrying on the road, have your backup plan ready.
              Fast and Reliable help for your emergency.</p> */}
          </Col>
        </Row>

        {/* <Row className="justify-content-center">
          <Col className='search_icon px-0 my-4' md={12} sm={12}>
            <ul>
              <li>
              <img src={icon1} className='img-fluid' alt='Truck-Repair' />
              <h4><a onClick={() => handleLinks("Truck Repair")}>Truck Repair</a></h4>
              </li>

              <li>
              <img src={icon2} className='img-fluid' alt='Trailer-Repair' />
              <h4><a onClick={() => handleLinks("Trailer Repair")}>Trailer Repair</a></h4>
              </li>

              <li>
              <img src={icon3} className='img-fluid' alt='Tire-Repair' />
              <h4><a onClick={() => handleLinks("Tire Repair and Sales")}>Tire Repair</a></h4>
              </li>

              <li>
              <img src={icon4} className='img-fluid' alt='Towing-Service'/>
              <h4><a onClick={() => handleLinks("Towing and Recovery")}>Towing Truck </a></h4>
              </li>
            </ul>
          </Col>
        </Row> */}

        <Form className='hero-form' onSubmit={handleSearch}>
          <Row className="align-items-center justify-content-center search_input search_input_hero">

            {/* <Col md={5} sm={12} className="category_search">
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Choose Service"
                  value={selectedSubcategory}
                  onClick={() => setShowSubcategory(!showSubcategory)}
                  readOnly
                  required
                />
              </InputGroup>
              {showSubcategory && (
                <Dropdown.Menu show className="w-100">
                  {subcategories.map((subcategory) => (
                    <Dropdown.Item
                      key={subcategory.id}
                      onClick={() => handleSubcategorySelect(subcategory.name)}
                    >
                      {subcategory.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              )}
            </Col> */}

            <Col md={8} sm={12} className="location_search">
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search by your city, state, country"
                  value={location}
                  onChange={handleLocationChange}
                  className="form-control"
                  required
                />
              </InputGroup>
              {showLocationSuggestions && (
                <Dropdown.Menu show className="w-100">
                  {loading ? (
                    <div className="spinner-container d-flex justify-content-center mt-4">
                      <Spinner animation="border" role="status" size="m" />
                    </div>) : (
                    <>
                      {locationSuggestions.length > 0 ? (
                        locationSuggestions.map((suggestion, index) => (
                          <Dropdown.Item key={index} onClick={() => handleLocationSelect(suggestion)}>
                            {suggestion.location}
                          </Dropdown.Item>
                        ))
                      ) : (
                        <Dropdown.Item disabled>No results found</Dropdown.Item>
                      )}
                    </>
                  )}
                </Dropdown.Menu>
              )}
            </Col>
            <Col md={2} sm={12} className="search_btn">
              <Button
                variant="primary"
                type="submit"
                className="btn-block"
              >
                <i className="fa fa-search" title="search"></i>  Search
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </section>

    <section className="home_callAction">
      <div className='container-fluid'>
        <div className="row justify-content-center align-items-center">

          <div className='col-md-4'>
            <div className='action_hightlight'>
             <h2><i class="fas fa-clock"></i> less than 30 min arrival</h2>
            </div>
          </div>

          <div className='col-md-4'>
            <div className='action_hightlight_call skew_bg'>
             <h2>Call : (800) 805-7820</h2>
            </div>
          </div>

          <div className='col-md-4'>
            <div className='action_hightlight_24'>
             <h2><i class="fas fa-phone"></i> 24/7 Towing Service</h2>
            </div>
          </div>

        </div>
      </div>
    </section>

  </>
  );
};

export default SearchSection;
